import React from "react"
import useRescuerLog from "hooks/useRescuerLog"
import moment from "moment"

export default function RescuerShiftsTab({username}) {

    const {data, isLoading} = useRescuerLog(username)

    if (isLoading)
        return <div id="spinner" className="center"/>

    if (!data || data.length === 0)
        return <div className="info">Nema smena</div>

    return <div className="shift-periods">
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>Skijalište</th>
                    <th>Početak</th>
                    <th>Kraj</th>
                    <th>Trajanje</th>
                </tr>
            </thead>
            <tbody>
                {data?.map((period, index) => <tr key={index}>
                    <td>
                        {period.area || ''}
                        {period.was_head && <span className="badge bg-primary ms-2">Vođa</span>}
                        {period.is_active && <span className="badge bg-success ms-2">Aktivna</span>}
                    </td>
                    <td>{period.start ? moment(period.start).format("DD.MM.YYYY HH:mm") : ''}</td>
                    <td>
                        {period.is_active ? '' : (period.end ? moment(period.end).format("DD.MM.YYYY HH:mm") : '')}
                    </td>
                    <td>{period.duration_display || ''}</td>
                </tr>)}
            </tbody>
        </table>
    </div>
}
